// Components
// import "./components/fonts.js";
import "./components/menu-mobile.js";
import "./components/sticky.js";
import "./components/the-events-calendar";
// import "./components/homepage-slider";
import "./components/quote-slider";
import "./components/testimonial-slider";
import "./components/form";
import "./components/ajax-load-more";
// Pages
import "./home.js";
